<div class="height-slider">
    <div class="title">{{ title }}</div>
    <div class="value">
        <span *ngIf="selectedFacet">{{ selectedFacet.label }}</span>
    </div>
    <div class="input-wrapper">
        @defer {
            <finder-ra-checkbox class="checkbox"
                *ngIf="showCheckbox"
                [checked]="enabled"
                (checkedChanged)="onCheck($event)">
                {{heightLabel}}
            </finder-ra-checkbox>
        }
        <div class="slider-wrapper">
            <div class="slider">
                <finder-font-icon size="xs" name="icon_ride-height" class="icon"></finder-font-icon>
                <input class="slider-input" type="range" list="tickmarks"
                    [(ngModel)]="value"
                    [min]="min" [attr.aria-valuemin]="min"
                    [max]="max" [attr.aria-valuemax]="max"
                    [attr.aria-valuetext]="selectedFacet?.label"
                    (ngModelChange)="setSelectedFacet()">
                <finder-font-icon size="s" name="icon_ride-height" class="icon"></finder-font-icon>
            </div>
            <datalist class="tickmarks" id="tickmarks">
                <option *ngFor="let facet of facets; let index = index"
                    [value]="index"
                    [label]="facet.height">
                </option>
            </datalist>
        </div>
    </div>
    <div class="subtitle">{{ subtitle }}</div>
</div>
